module.exports = __webpack_public_path__ + "img/logo-csepel-metal.63a2832.png";